module.exports = __webpack_public_path__ + "img/l.83384147.svg";